import { useQuery } from 'react-query'
import { fetchParamountOriginals } from '../services/api'

export const useParamountOriginals = options => {
  return useQuery('paramountOriginals', fetchParamountOriginals, options)
}
